module.exports = {
    mob: { max: '767px' }, // mobile
    tab: { min: '768px', max: '1199px' }, // tablet
    lap: { min: '1200px', max: '1365px' }, // laptop
    des: { min: '1366px' }, // desktop
};
